import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type dbdeCredType = CarrierLogisticsCredType
export const dbdeDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const dbde: CarrierDef<dbdeCredType> = {
  name: 'Double D Express',
  scac: 'dbde',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'profinder', 'tracking', 'pickup'],
  documentTypes: dbdeDocumentTypes,
}
